import React, { useEffect, useState } from 'react';
import { DatePicker, Select, Button } from 'antd';
import moment from 'moment';
import axios from 'axios';
import { Column } from '@ant-design/plots';
import client from '../../../../lib/feathers';
import styles from './index.module.scss';

const { RangePicker } = DatePicker;
const { Option } = Select;

const BarChart = ({
  deviceNameArr,
  deviceTable,
  deviceIndex,
  tableName,
  onDevice,
  onUnit,
  excelUrl,
  excelName,
}) => {
  const [searchStartDate, setSearchStartDate] = useState(
    moment().startOf('month').valueOf()
  );
  const [searchEndDate, setSearchEndDate] = useState(
    moment().endOf('month').add(1, 'day').valueOf()
  );
  const [DeviceName, setDeviceName] = useState([]);
  const [filter, setFilter] = useState({
    timeStart: searchStartDate,
    timeEnd: searchEndDate,
    unit: 'day',
    chartType: 'barChart',
    // deviceName: '',
    tableName,
  });
  const [chartData, setChartData] = useState([]);

  useEffect(() => {
    if (deviceTable && deviceIndex) {
      const NameArr = [];
      deviceTable.map((item) => {
        const database = client.service(item);
        database
          .find({})
          .then((res) => {
            res.data.map((dataset) => NameArr.push(dataset[deviceIndex]));
            const filteredArray = NameArr.filter(function (ele, pos) {
              return NameArr.indexOf(ele) === pos;
            });
            setDeviceName(filteredArray);
          })
          .catch((error) => {
            console.log(error);
          });
        return true;
      });
      //   const newFilter = [...filter];
      //   newFilter.deviceName = NameArr[0];
      //   setFilter(newFilter);
    }
    if (deviceNameArr) {
      setDeviceName(deviceNameArr);
    }
  }, [deviceTable, deviceIndex, deviceNameArr]);

  useEffect(() => {
    let str = '';
    // for (const key in filter) {
    //   str += `${key}=${filter[key]}&`;
    // }
    Object.keys(filter).forEach((key) => {
      str += `${key}=${filter[key]}&`;
    });
    console.log(str);
    axios(`/ezcon/api/efficacyStatisticChart?${str}`, {
      method: 'GET',
      headers: {
        authorization: window.localStorage['feathers-jwt'],
      },
    })
      .then((res) => {
        console.log(res);
        setChartData(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [filter]);
  const config = {
    data: chartData,
    isGroup: true,
    xField: 'type',
    yField: 'sales',
    seriesField: 'name',
    label: {
      // 可手动配置 label 数据标签位置
      position: 'middle',
      // 'top', 'bottom', 'middle',
      // 配置样式
      style: {
        fill: '#FFFFFF',
        opacity: 0.6,
      },
    },
    xAxis: {
      title: {
        text: '類別',
        style: {
          fontSize: 12,
        },
      },
    },
    yAxis: {
      title: {
        text: '次數(次）',
        style: {
          fontSize: 12,
        },
      },
    },
    meta: {
      sales: {
        alias: '次數',
      },
    },
  };

  return (
    <>
      <div>
        <div>
          <div className={styles.FilterTitle}>
            時間：
            {onUnit && (
              <Select
                value={filter.unit}
                onChange={(value) => {
                  const newFilter = { ...filter };
                  newFilter.unit = value;
                  setFilter(newFilter);
                }}
              >
                <Option value="hour">小時</Option>
                <Option value="day">日</Option>
                <Option value="month">月</Option>
                <Option value="year">年</Option>
              </Select>
            )}
            {filter.unit === 'hour' ? (
              <DatePicker
                defaultValue={moment().format('YYYY-MM-DD')}
                onChange={(value) => {
                  const newFilter = { ...filter };
                  newFilter.timeStart = moment(value).valueOf();
                  newFilter.timeEnd = moment(value).valueOf();
                  setFilter(newFilter);
                }}
              />
            ) : (
              <RangePicker
                picker={filter.unit}
                defaultValue={[
                  moment().startOf('month'),
                  moment().endOf('month'),
                ]}
                onChange={(value) => {
                  console.log(value[2]);
                  setSearchStartDate(moment(value[0]).format('YYYY-MM-DD'));
                  setSearchEndDate(moment(value[1]).format('YYYY-MM-DD'));
                  const newFilter = { ...filter };
                  newFilter.timeStart = moment(value[0]).valueOf();
                  newFilter.timeEnd = moment(value[1])
                    .add(1, `${filter.unit}s`)
                    .valueOf();
                  setFilter(newFilter);
                }}
              />
            )}
          </div>
          {onDevice && (
            <div className={styles.FilterTitle}>
              類型：
              <Select
                value={filter.deviceName}
                style={{ width: 120 }}
                showSearch
                placeholder="請選擇"
                onChange={(value) => {
                  const newFilter = { ...filter };
                  newFilter.deviceName = value;
                  newFilter.deviceTitle = deviceIndex;
                  setFilter(newFilter);
                }}
              >
                <Option value="">全部</Option>
                {DeviceName.map((x) => (
                  <Option value={x}>{x}</Option>
                ))}
              </Select>
            </div>
          )}
          <div className={styles.FilterTitle}>
            <Button
              onClick={async () => {
                let str = `timeStart=${filter.timeStart}&timeEnd=${filter.timeEnd}&`;
                if (filter.deviceName !== '全部' && filter.deviceName) {
                  str += `deviceName=${filter.deviceName}&deviceTitle=${deviceIndex}`;
                }
                const result = await fetch(`${excelUrl}?${str}`, {
                  method: 'GET',
                  headers: {
                    authorization: window.localStorage['feathers-jwt'],
                  },
                });
                console.log({ result });
                const blob = await result.blob();
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = `${excelName}.xlsx`;
                a.click();
                window.URL.revokeObjectURL(url);
              }}
            >
              匯出
            </Button>
          </div>
        </div>
        <div style={{ marginTop: 40 }}>
          <Column {...config} />
        </div>
      </div>
    </>
  );
};

export default BarChart;
